<div [ngClass]="{ 'form-row': to?.className === 'xilo-input' }">
  <div class="address-container" [ngClass]="{ 'form-item': to?.className === 'xilo-input' }">
    <label class="label">
      {{ to.label }}
      <span *ngIf="to?.required" class="required-indicator">*</span>
    </label>
    <div 
      class="zillow-link" 
      matTooltip="Open in Zillow"
      *ngIf="to.className === 'intake-input'" 
      matTooltipPosition="above" 
      (click)="formControl.value ? openZillow(formControl.value): ''"
    >
      <img [src]="formControl.value ? '/assets/icons/zillow1.svg' : '/assets/icons/zillow.svg'" alt="">
    </div>
      
    <form autocomplete="off">
      <input type="text" hidden autocomplete="false" />
      <input
        #addressInput
        type="text"
        [class]="to.className || 'xilo-input'"
        [ngClass]="[
        formControl.invalid ? 'required-input' : '',
        (formControl.invalid && formControl.touched) ? ' border-red ': '']"
        [formlyAttributes]="field"
        [formControl]="formControl"
        ngx-google-places-autocomplete
        #placesRef="ngx-places"
        (onAddressChange)="handleAddressChange($event)"
        (blur)="touched()"
        (keydown.enter)="$event.preventDefault()"
        (keydown.shift.enter)="$event.preventDefault()"
        (keydown.control.enter)="$event.preventDefault()"
        (keydown.meta.enter)="$event.preventDefault()"
      />
    </form>

    <!-- errors showing -->
    <label *ngIf="errorMessage" class="invalid-feedback">{{
      errorMessage
    }}</label>

    <!-- <p *ngIf="formatted_address != ''" class="full-address__formatted text-gray-400">{{formatted_address}}</p> -->
    <!-- <p class="full-address__formatted text-gray-400">{{ formControl.value }}</p> -->
    <!-- <p  *ngIf="formControl.value !='' && formatted_address != ''" (click)="editAddress()" class="full-address__edit text-blue-200 underline mt-4">Edit Address - Add Suite/Apt/Unit/etc.</p> -->
  </div>
</div>
